import { jeopardyApi } from "../api/jeopardy";

export const useJeopardy = () => {

    const updateAccountablePersons = async ({ jeopardyId, payload }: { jeopardyId: any, payload: any }) => {
        const response = await jeopardyApi.updateAccountablePersons({ jeopardyId, payload: payload[0] });
        return response;
    };

    const updateJeopardyTask = async ({ jeopardyId, payload }: {
        jeopardyId: string,
        payload: {
            "notes": string;
            "jeopardy_tasks": [
                {
                    "task_id": string;
                    "value": boolean;
                }
            ]
        }
    }) => {
        const response = await jeopardyApi.updateTasks({ jeopardyId, payload });
        return response;
    };

    const updateAcknowledgementStatus = async ({ jeopardyId, isRead }: { jeopardyId: any, isRead: any }) => {
        const response = await jeopardyApi.updateMarkAsRead({ jeopardyId, isRead });
        return response;
    };

    return {
        updateAccountablePersons,
        updateJeopardyTask,
        updateAcknowledgementStatus
    };

};